import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { LinkButton } from '@/components/ui/Button/LinkButton';
import { Text } from '@/components/ui/Typography/Body/Text';
import { PREV_PATH_CONTEXT_LOCATION_STATE_KEY } from '@/context/PrevPathContext';
import { hotlineClientText } from '@/feature/hotline/client/constant/text';
import { hotlineClientScheduleEndStyle } from '@/feature/hotline/client/detail/negotiate/component/HotlineClientSchedule/HotlineClientScheduleEnd/style';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 匿名コンサルホットライン 調整スケジュール（完了・キャンセル）
 */
export const HotlineClientScheduleEnd = (props) => {
    const { className = '', id, isCanceled, requestId } = props;
    const style = hotlineClientScheduleEndStyle();
    return (_jsxs("div", Object.assign({ className: style.base({ class: className }) }, { children: [_jsx(Text, Object.assign({ color: 'base', isBold: true, size: 'md' }, { children: isCanceled ? '相談がキャンセルされました' : '相談が完了しました' })), _jsxs("div", Object.assign({ className: style.buttonWrap() }, { children: [_jsx(LinkButton, Object.assign({ color: 'navy', routerLinkAttributes: {
                            state: {
                                [PREV_PATH_CONTEXT_LOCATION_STATE_KEY]: pagePath.hotline.client.detailNegotiate(id),
                            },
                        }, size: 'md', to: pagePath.hotline.client.contactInput(id, `${requestId}`) }, { children: hotlineClientText.action.contact() })), _jsx(LinkButton, Object.assign({ color: 'orange', routerLinkAttributes: {
                            state: {
                                [PREV_PATH_CONTEXT_LOCATION_STATE_KEY]: pagePath.hotline.client.detailNegotiate(id),
                            },
                        }, size: 'md', to: pagePath.hotline.client.reorderInput(id, `${requestId}`) }, { children: hotlineClientText.action.reorder() }))] }))] })));
};
